import { useNavigate } from "react-router-dom";

export const useTestTimePageVM = () => {
  const navigate = useNavigate();

  const onConfirmClick = () => {
    navigate("/Login");
  };

  return {
    actions: {
      onConfirmClick,
    },
  };
};